import styles from "Developers/LuiSanchez/assets/styles.module.scss";
import arrowIcon from "Developers/LuiSanchez/assets/arrow-icon.svg";
import useCarouselPerfilLuis from "Componentes/BandList/useCarouselPerfilLuis";

type BandListProps = {
  title: string;
  images: Array<string>;
};

const BandList: React.FC<BandListProps> = ({ images, title }) => {
  const imagesLenght = images.length;
  const { nextImg, prevImg, imageListRef } =
    useCarouselPerfilLuis(imagesLenght);

  return (
    <div data-testid='BandList' className={`${styles.box}`}>
      <div className={`${styles.boxHeader}`}>{title}</div>
      <button title='Next' onClick={nextImg} className={`${styles.arrow}`}>
        <img src={arrowIcon} alt='arrow-image' />
      </button>
      <button title='Previus' onClick={prevImg} className={`${styles.arrowL}`}>
        <img src={arrowIcon} alt='arrow-imageL' />
      </button>
      <div ref={imageListRef} className={` ${styles.bandList}`}>
        {images.map((img, index) => (
          <img key={`I${index}`} src={img} alt='band-image' />
        ))}
      </div>
    </div>
  );
};
export default BandList;
